import { useEffect } from "react";

export const IDLE_TIMEOUT_MS = 60_000;

const ACTIVITY_EVENTS = [
  "pointerdown",
  "pointermove",
  "keydown",
  "wheel",
  "scroll",
];

// onIdle must be stable, or every render restarts the wait.
export function useIdleTimeout({ enabled, onIdle }) {
  useEffect(() => {
    if (!enabled) return;

    let timeout;
    function restart() {
      clearTimeout(timeout);
      timeout = setTimeout(onIdle, IDLE_TIMEOUT_MS);
    }

    // Capture, so non-bubbling scroll and events the embed stops still count.
    const options = { capture: true, passive: true };
    ACTIVITY_EVENTS.forEach((type) =>
      window.addEventListener(type, restart, options),
    );
    restart();

    return () => {
      clearTimeout(timeout);
      ACTIVITY_EVENTS.forEach((type) =>
        window.removeEventListener(type, restart, options),
      );
    };
  }, [enabled, onIdle]);
}
